import { withTenantKey } from '@/libs/storageKeys'

const getCreateDraftStorageKey = () => withTenantKey('partner-order-request-create-draft')
const getEditDraftStorageKey = id => withTenantKey(`partner-order-request-edit-draft-${id}`)

const saveOrderRequestDraft = (key, payload) => {
  localStorage.setItem(key, JSON.stringify({
    savedAt: new Date().toISOString(),
    payload,
  }))
}

const readOrderRequestDraft = key => {
  const value = localStorage.getItem(key)
  if (!value) {
    return null
  }

  try {
    return JSON.parse(value)
  } catch (err) {
    return null
  }
}

const clearOrderRequestDraft = key => {
  localStorage.removeItem(key)
}

export {
  getCreateDraftStorageKey,
  getEditDraftStorageKey,
  saveOrderRequestDraft,
  readOrderRequestDraft,
  clearOrderRequestDraft,
}
